/**
 * @Author: Hanjianxin
 * @Desc: 所有的api接口
 * @Date: 2019-07-31
 */
import { get, post } from "./axios_service.js";
import axios from "axios";
import { formateObjToParamStr } from "../filters/filters";

export default class AxiosApi {
  constructor() {}

  static getRolesList(params) {
    return post("/login", params, "form");
  }
  static postUpdatePasswd(params) {
    return post("/updatePasswd", params, "form");
  }
  /// 查询子账号对应权限菜单(根据角色ID查询)
  static postselChildAccountCooperatorMenus(params) {
    return post("/selChildAccountCooperatorMenus", params, "form");
  }
  static getCurrentAccountBalance(params) {
    return get("/cooperator/balance/current", params, "form");
  }
  // 删除绑定账户
  static postDeleteWhiteList(params) {
    return post("/web/xwbank/delete/offline/white/list", params, "form");
  }

  // 商户首页 & 代理商首页数据
  static getIndexDataMerchantAndAgent(params) {
    return get("/home/cooperatorOrAgent", params, "form");
  }
  // 查询商户是否存在未下载变更函
  static getChangeNoticeLetter(params) {
    return get(
      "/cooperatorChannelChangeNoticeLetter/hasUnDownload",
      params,
      "form"
    );
  }

  // 商户 && 代理商切换商户操作
  static postIndexAndAgentChangeCoor(params) {
    return post("/chang/user/cooperator", params, "form");
  }
  // 消息未读数量
  static getNumberUnreadMessages(params) {
    return get("/deal/notice/numberUnreadMessages", params, "form");
  }
  // 首页 - 佣金明细列表
  static getIndexAgentCommissionDesc(params) {
    return get("/web/agent/transaction/list", params, "form");
  }
  // 首页 - 数据
  static getIndexAgentData(param) {
    return get("/web/index/agent/transaction/detail", param, "form");
  }

  // 商户首页 - 首页数据看板金额查询
  static getDataBoardMoney(param) {
    return get(
      "/whiteness/cooperator/index/queryIndexDataAmount",
      param,
      "form"
    );
  }
  // 商户首页 - 阶梯费率展示
  static queryPhaseRule(param) {
    return get("/index/query/distributePhaseRule", param, "form");
  }
  // 消息未读数量
  static getNumberUnreadMessages(params) {
    return get("/deal/notice/numberUnreadMessages", params, "form");
  }
  // 获取短信验证码
  static postGetCode(params) {
    return post("/web/login/sms", params, "form");
  }
  // 验证码免密登录
  static postCodeLogin(params) {
    return post("/validation/sms/code", params, "form");
  }
  //协议导出记录列表
  static getExportRecordList(params) {
    return get("/worker/get/worker/contract/export/record", params, "form");
  }
  //主账号首次登录
  static postPrimaryAccountFirstLogin(params) {
    return post("/primary/account/first/login", params, "form");
  }
  //主账号信息变更-发送验证码
  static postAccountInfoChangeSendSms(params) {
    return post("/account/info/change/send/sms", params, "form");
  }
  //主账号信息变更-校验验证码
  static postAccountInfoChangeVerifySmsCode(params) {
    return post("/account/info/change/verify/sms/code", params, "form");
  }
  //主账号信息变更-信息提交
  static postUpdatePrimaryAccountInfo(params) {
    return post("/update/primary/account/info", params, "form");
  }
  //TT-00 根据父级code查询其下级行政区域
  static getAreaDictFindParentAreaCod(params) {
    return get("/area/dict/find/dict/area/by/parentAreaCode", params, "form");
  }

  /**
   * 交易中心
   * */
  //交易中心---资金下发管理====批次数据准备列表查询
  static getQueryBatch(params) {
    return get("/batch/queryBatch", params, "form");
  }
  //交易中心---资金下发管理====批次数据准备详情
  static postQueryBatchInfo(params) {
    return post("/batch/queryBatchInfo", params, "form");
  }
  //交易中心---资金下发管理====批次校验明细查询
  static postQueryBatchListByBatchId(params) {
    return post("/batchList/queryBatchListByBatchId", params, "form");
  }
  //交易中心---资金下发管理======批次数据准备==新增批次
  static postbatchImport(params) {
    return post("/batch/batchImport", params, "multipart");
  }
  //交易中心---资金下发管理======批次数据准备==取消批次
  static postCancelBatch(params) {
    return post("/batch/cancelBatch", params, "form");
  }
  //交易中心--资金下发管理====批次数据准备支付
  static postbatchSubmit(params) {
    return post("/batch/batchSubmit", params, "form");
  }
  //交易中心---资金下发管理====批次数据准备明细查询
  static getQueryBatchBatchId(params) {
    return get("/batchList/batchListDealInfoQuery", params, "form");
  }
  //交易中心---资金下发管理====批次数据提交-批次下发列表查询
  static postBatchListQuery(params) {
    return post("/batchList/batchListQuery", params, "form");
  }
  //交易中心---资金下发管理====批次数据提交-修改信息
  static postModifyBatchList(params) {
    return post("/batchList/modifyBatchList", params, "form");
  }
  //交易中心---资金下发管理====批次数据提交-删除下发列
  static postRemoveBatchList(params) {
    return post("/batchList/removeBatchList", params, "form");
  }
  ////交易中心---批次数据提交-发送支付短信
  static postSendBatchPaySms(params) {
    return post("/batch/sendBatchPaySms", params, "form");
  }
  ////交易中心---批次数据准备提交-验证短信验证码并支付
  static postPaySmsSubmit(params) {
    return post("/batch/smsPayVerify", params, "form");
  }

  // 交易中心---资金下发管理 -- 多批次数据准备 - 列表 02
  static getMultipleBatchesData(params) {
    return get("/batch/multiple/findPage", params, "form");
  }
  // 交易中心---资金下发管理 -- 多批次数据准备 - 取消 04
  static postMultipleBatchesCancel(params) {
    return post("/batch/multiple/cancel", params, "form");
  }
  // 交易中心---资金下发管理 -- 多批次数据准备 - 详情 03
  static getMultipleBatchesDetail(params) {
    return get("/batch/multiple/findDetail", params, "form");
  }
  // 交易中心---资金下发管理 -- 多批次数据准备 - 详情列表 10
  static getMultipleBatchesDetailList(params) {
    return get("/batch/list/findPage", params, "form");
  }
  // 交易中心---资金下发管理 -- 多批次数据准备 - 支付页面详情 08
  static getMultipleBatchesSubmitDetail(params) {
    return get("/batch/multiple/findPayDetail", params, "form");
  }
  //交易中心---资金下发管理 -- 多批次数据提交-修改信息 13
  static postMultipleBatchesChange(params) {
    return post("/batch/list/update", params, "json");
  }
  //交易中心---资金下发管理 -- 多批次数据提交 - 发送验证码 06
  static postMultipleSendBatchPaySms(params) {
    return post("/batch/multiple/sendPaySms", params, "form");
  }
  //交易中心---资金下发管理 -- 多批次数据提交 - 支付 07
  static postMultiplePaySmsSubmit(params) {
    return post("/batch/multiple/verifyIssue", params, "form");
  }
  //交易中心---资金下发管理 -- 多批次数据提交 -  删除下发列 12
  static postMultipleRemoveBatchList(params) {
    return post("/batch/list/deletes", params, "json");
  }
  //交易中心---资金下发管理 -- 多批次数据准备详情 - 订单状态查询 14
  static getMultipleOrderStatusList(params) {
    return get("/batch/list/findDistributeStatus", params, "json");
  }
  //交易中心---资金下发管理 -- 多批次数据准备 - 付款状态查询 15
  static getMultiplePayStatusList(params) {
    return get("/batch/list/findOrderStatus", params, "json");
  }
  //交易中心---资金下发管理 -- 多批次数据准备及单批次数据准备 - 删除订单
  static postDelBatchList(params) {
    return post("/batch/removeBatch", params, "form");
  }
  // 资金下发管理-服务费明细列表
  static postServiceDetailList(param) {
    return post("/service/detail/list", param, "form");
  }

  //交易中心---用户管理====用户列表分页查询
  static postQqueryWorkers(params) {
    return post("/worker/queryWorkers", params, "form");
  }
  //交易中心---用户管理====用户签约协议查看
  static postQqueryWorkersPro(params) {
    return post("/worker/queryWorkersPro", params, "form");
  }
  //交易中心---用户管理-----根据id查用户信息
  static postQueryWorkerById(params) {
    return post("/worker/queryWorkerById", params, "form");
  }
  //交易中心---用户管理-----修改用户信息
  static postSaveWorkerById(params) {
    return post("/worker/saveWorkerById", params, "form");
  }
  //交易中心---用户管理----根据Id删除用户信息
  static postDeleteWorkerById(params) {
    return post("/worker/deleteWorkerById", params, "form");
  }

  static postdelChildAcc(params) {
    return post("/delChildAcc", params, "form");
  }
  //下发通道
  static postSelectDistributeChannel(params) {
    return post("/distributeChannel/selectDistributeChannel", params, "form");
  }
  //下发公司
  static postSelectByCompanyName(params) {
    return post("/distributeChannel/selectByCompanyName", params, "form");
  }
  //商户列表
  static postSelectCooperatorIdList(params) {
    return post("/batch/getCooperatorIdList", params, "form");
  }
  //商户列表 - 选择登录账号页面
  static postAccountCooperatorsList(params) {
    return post("/find/cooperator/list", params, "form");
  }
  // 商户列表 - 选择登录账号页面 -变更手机号获取验证码
  static postPhoneSendCode(params) {
    return post("/web/change/phone/send/sms", params, "form");
  }
  // 商户列表 - 选择登录账号页面 - 变更手机号提交
  static postChangePhoneExecute(params) {
    return post("/web/change/phone/execute", params, "json");
  }

  /**
   * 数据中心
   */
  //收款用户交易统计
  static getGatheringUser(params) {
    return get("/dataCenter/ReceivableTransactionStatistics", params, "form");
  }
  //收款用户交易统计详情
  static postGatheringUserDetails(params) {
    return post(
      "/dataCenter/ReceivableTransactionStatisticsDetails",
      params,
      "form"
    );
  }
  //代理商交易统计
  static postBusinessStatistics(params) {
    return post("/dataCenter/AgentTransactionStatistics", params, "form");
  }
  //代理商交易统计详细
  static postQuestAgentDetails(params) {
    return post("/dataCenter/AgentTransactionStatisticsList", params, "form");
  }
  //商户交易统计
  static getQueryBusinessStatistics(params) {
    return get("/dataCenter/BusinessStatistics", params, "form");
  }
  //商户交易统计明细
  static postQueryBusinessDetails(params) {
    return post("/dataCenter/BusinessStatisticsDetail", params, "form");
  }
  //历史结算数据列表分页
  static getHistoryCmsBatchListPage(params) {
    return get("/history/webBatchListListPage", params, "form");
  }
  //历史结算回单数据列表导出
  static getHistoryCmsBatchListReceiptExportAsync(params) {
    return get("/history/webBatchListReceiptExportAsync", params, "form");
  }
  //历史数据导出列表查询
  static getQueryDataExportRecordList(params) {
    return get("/history/queryDataExportRecordList", params, "form");
  }
  //web代理商历史交易统计[列表分页]
  static postWebBrokerageListPage(params) {
    return post("/history/webBrokerageListPage", params, "json");
  }
  //]代理商历史交易统计详情[列表查询]
  static postAgentTransactionStatisticsList(params) {
    return post("/history/AgentTransactionStatisticsList", params, "json");
  }

  /**
   * 管理中心
   */
  //账户管理
  static selCooChildAccount(params) {
    return post("/selCooChildAccount", params, "form");
  }
  //管理中心 - 新增账号
  static postAddNewChildAcc(params) {
    return post("/addNewChildAcc", params, "form");
  }
  //管理中心 - 检测账号是否被占用
  static postcheckChildTheLoginName(params) {
    return post("/checkChildTheLoginName", params, "form");
  }
  //管理中心 - 检测邮箱是否被占用
  static postcheckChildTheEmail(params) {
    return post("/checkChildTheEmail", params, "form");
  }
  //管理中心 - 检测手机号码是否被占用
  static postcheckChildThePhone(params) {
    return post("/checkChildThePhoneNo", params, "form");
  }
  //修改密码
  static postupdateChildState(params) {
    return post("/updateChildState", params, "form");
  }
  //管理中心 - 修改子账号密码（重置密码操作）
  static postAmendUserPwd(params) {
    return post("/amendUserPassword", params, "form");
  }
  //管理中心 - 编辑权限--查询子账号概要信息（子账号权限分配页面）
  static postselChildAccProbablyMsg(params) {
    return post("/selChildAccProbablyMsg", params, "form");
  }
  //理中心 - 编辑权限==查询权限树
  static postPrivilegeTree(params) {
    return post("/cooperator/privilege/tree", params, "form");
  }
  //管理中心 - 编辑权限--修改子账号权限（子账号权限分配页面）
  static postUpdateChildAccPrivilege(params) {
    return post("/updateChildAccPrivilege", params, "form");
  }
  //管理中心 - 查询你指定子账号所有权限ID
  static postselChildAccAllPrivilege(params) {
    return post("/selChildAccAllPrivilege", params, "form");
  }
  // 功能配置 -- 查询商户配置
  static coorConfigInfo(params) {
    return get(
      "/cooperator/functionConfig/query/cooperatorConfigInfo",
      params,
      "form"
    );
  }
  // 功能配置 -- 保存商户配置
  static saveCoorConfig(params) {
    return post(
      "/cooperator/functionConfig/edit/cooperatorConfigInfo",
      params,
      "json"
    );
  }

  /**
   * 财务中心
   */
  //交易中心-账户余额列表查询
  static balanceAccount(params) {
    return post("/cooperator/balance/list", params, "form");
  }
  //充值记录
  static getAccountLog(params) {
    return get("/cooperator/recharge/record/list", params, "form");
  }
  //开票信息查询 - 发票2.0
  static invoiceInformation(params) {
    return post("/cooperator/query/all/variety/content", params, "form");
  }
  //图片回显
  static fileEchoDisplay(params) {
    return post("/cooperator/file/getFileBase", params, "form");
  }
  //开票明细
  static viewBillingDetails(params) {
    return post("/cooperator/sel/invoice/order/info", params, "form");
  }
  // 作废详情
  static getInvalidDetail(params) {
    return get("/cooperator/find/invoice/invalid/detail", params, "form");
  }
  //提交发票申请
  static submitInvoiceApply(params) {
    return post("/cooperator/dingding/apply/invoice", params, "json");
  }
  //电子回单查询
  static electronicReceipt(params) {
    return post("/cooperator/receipt/list", params, "form");
  }
  // 充值记录 - 开票申请 - 获取商户开票类目
  static getInvoiceVariety(params) {
    return post("/cooperator/query/invoice/variety", params, "form");
  }
  // 充值记录 - 退款申请
  static postApplyRefund(params) {
    return post("/web/recharge/record/xwbankRefundToCard", params, "form");
  }
  // 充值记录 - 退款确认前获取验证码
  static postConfirmRefundMsg(params) {
    return post(
      "/web/recharge/record/xwbankSendTransferOutConfirmMessage",
      params,
      "form"
    );
  }
  // 充值记录 - 确认退款
  static postConfirmRefund(params) {
    return post(
      "/web/recharge/record/xwbankTransferOutConfirm",
      params,
      "form"
    );
  }
  // 充值记录 - 发票信息
  static getInvoiceInfo(params) {
    return get("/get/cooperator/invoice/msg", params, "form");
  }
  // 完税证明列表
  static getTaxProveList(params) {
    return get("/cooperator/tax/prove/pageList", params, "form");
  }
  // 导出报税文件
  static getExportTaxProve(params) {
    return get("/web/export/tax/document", params, "form");
  }
  // 完税证明详情
  static getTaxProveDetail(params) {
    return get("/cooperator/tax/prove/detail/findPage", params, "form");
  }
  // 开通资金安全账户 - 商户鉴权信息提交
  static postOpenSecurityAccountOne(params) {
    return post("/cooperator/pabk/authentication", params, "json");
  }
  // 开通资金安全账户 - 商户鉴权信息detail   del???
  static postOpenSecurityAccountDetail() {
    return get("/cooperator/pabk/findDetail", {}, "form");
  }
  // 开通资金安全账户 - 开户前获取验证码
  static getOpenSecuritySmsCode(params) {
    return get("/cooperator/pabk/sendSmsIdentCode", params, "form");
  }
  // 开通资金安全账户 - 开户
  static postOpenSecurityAccount(params) {
    return post("/cooperator/pabk/account/open", params, "form");
  }
  // 新网银行新增充值白名单
  static postAddWhiteOffline(params) {
    return post("/web/xwbank/add/offline/white/list", params, "form");
  }
  //余额管理--充值打款信息
  static getRechargeInfo(params) {
    return get("/cooperator/summary/payment/info", params, "form");
  }
  // 新网银行列表
  static postPayAccountList(params) {
    return post("/web/xwbank/offline/white/list/query", params, "form");
  }
  // 账号列表
  static getAccountList(params) {
    return get("/cooperator/balance/record/list", params, "form");
  }
  // 调取各银行余额信息
  static getPaymentChannelInfo(params) {
    return get("/cooperator/summary/payment/channel/info", params, "form");
  }
  // 入驻网商提交信息
  static postSubmitInfoRegisteWs(params) {
    return post("/web/mbkco/bank/cooperator/register/mbk", params, "json");
  }
  //发票申请--列表
  static getInvoiceApplyList(params) {
    return get("/batch/invoice/findPage", params, "form");
  }
  //发票申请--提交发票申请
  static postInvoiceApplysub(params) {
    return post("/batch/invoice/approval", params, "form");
  }
  //获取发票地址
  static getInvoiceAddr(params) {
    return get("/get/cache/invoice/location", params, "form");
  }
  // 充值记录 - 金额明细
  static postAmountDetail(params) {
    return post("/query/invoice/amountDetail", params, "form");
  }
  // 充值记录 - 开票记录 - 列表
  static postBillingRecordList(params) {
    return post("/query/invoice/record", params, "json");
  }
  // 充值记录 - 开票记录 - 可开票金额
  static getBillingRecordAmount(params) {
    return get("/query/invoice/amount", params, "form");
  }
  // 充值记录 - 开票记录 - 开票信息
  static postBillingRecordDetail(params) {
    return post("/getBillingInfo", params, "form");
  }
  // 充值记录 - 导出发票
  static postExportInvoicePhoto(params) {
    return post("/export/invoice/photo/for/web", params, "json");
  }
  // 充值记录 - 导出记录
  static getExportInvoiceRecord(params) {
    return get("/common/data/export/record/page", params, "form");
  }
  // 开票申请 - 详情
  static getInvoiceDetail(params) {
    return get("/cooperator/balance/record/list", params, "form");
  }
  // 开票信息 - 开票
  static postInvoiceSubmit(params) {
    return post("/cooperator/dingding/apply/invoice", params, "json");
  }
  // 开票信息 - 保存开票信息
  static postInvoiceSave(params) {
    return post("/updateBillingInfo", params, "json");
  }
  // 预开发票 - 预开发票详情
  static getPinPerDetail(params) {
    return get("/cooperator/balance/record/list", params, "form");
  }
  // 余额管理账单列表-回显上一次的充值信息
  static getCooperatorInfoAlipay(params) {
    return get(
      "/cooperator/get/last/recharge/record/info/for/alipay",
      params,
      "form"
    );
  }
  // 指定充值记录列表
  static postRecordRechargeList(params) {
    return post("/assign/record/invoice", params, "form");
  }
  // 开票申请 - 关联任务
  static postInvoiceTaskList(params) {
    return post("/find/invoice/related/position/list", params, "form");
  }
  // 管理费退还记录
  static getFeeRefundRefundList(params) {
    return get(
      "/web/page/query/pricing/service/charge/return/record",
      params,
      "form"
    );
  }
  //  查询管理费退还明细
  static getFeeRefundDesc(params) {
    return get(
      "/batch/list/salary/query/service/charge/return/record/detail",
      params,
      "form"
    );
  }
  /**
   * 数据中心
   */
  //收款用户交易导出
  static exportStatisticsUrlStr(parmes) {
    window.open(
      axios.defaults.baseURL +
        "/dataCenter/exportReceivableTransactionStatistics" +
        "?" +
        formateObjToParamStr(parmes)
    );
  }
  // 手动充值
  static postManualCharge(param) {
    return post("/cooperator/recharge/record/submit", param, "form");
  }
  // 月环比数据列表
  static getMonthOnMontData(param) {
    return get("/web/agent/transaction/rate", param, "form");
  }
  // 佣金结算订单 - 列表查询
  static getAgentBrokerageSettleRecord(param) {
    return get("/dataCenter/agentBrokerageSettleRecordListPage", param, "form");
  }
  // 佣金结算订单 - 提现详情 - 列表查询
  static getAgentBrokerageWithdrawRecord(param) {
    return get("/dataCenter/agentBrokerageWithdrawRecordList", param, "form");
  }

  /**
   * 管理中心 ==》 接口对接
   * */
  // 获取验证码
  static sendOpenApiSms(param) {
    return post("/deal/api/get/phonecode", param, "form");
  }

  // 查询单个商户的openAPI配置信息
  static getOpenApiConfig(param) {
    return post("/deal/api/query/openapiconf", param, "form");
  }

  // 查看密钥
  static getOpenApiKey(param) {
    return post("/deal/api/check/phonecode", param, "form");
  }

  // 新增 & 修改配置
  static saveOpenApiConfig(param) {
    return post("/deal/api/save/openapiconf", param, "form");
  }

  //客户公海池
  static customesearche(params) {
    return get("/xbb/testCustomerDel", params, "form");
  }
  //客户公海池列表请求
  static customesearcheList(params) {
    return get("/xbb/customer", params, "form");
  }

  // 商户接口对接发送授权验证码接口
  static postSendSignMsg(params) {
    return post("/deal/api/protocol/sendEsignMsg", params, "json");
  }
  // 商户接口对接创建CFCA合同
  static postCreateSignContrat(params) {
    return post("/deal/api/protocol/createEsignContract", params, "form");
  }

  /**
   * 根据接口修改信息 ==》 根据接口修改信息
   * */
  // 登录之前的oem信息 - 域名
  static getOemInfo() {
    return get("/user/oem/query/web/info", {}, "form");
  }
  // 页面内的oem信息 - 商户ID
  static getOemInfoPage() {
    return get("/user/oem/get/info", {}, "form");
  }
  // oem配置更新（创建&编辑）
  static postOemModify(params) {
    return post("/user/oem/save/or/modify", params, "form");
  }

  /**
   * 找回密码
   * */
  // 忘记密码账号校验
  static postFindPwdInfo(param) {
    return post("/forget/account/pwd", param, "form");
  }
  // 发送验证码
  static postFindPwdGetCode(param) {
    return post("/retrieve/pwd/send/sms", param, "form");
  }
  // 验证码校验
  static postSmsCodeValidate(param) {
    return post("/retrieve/pwd/validation/sms/code", param, "form");
  }
  // 重置密码
  static postChangePwd(param) {
    return post("/retrieve/account/pwd", param, "form");
  }

  /**
   * 用户签约协议增加批量导入
   * */
  // 确认签约
  static postConfirmImportFileSign(param) {
    return post("/batchImport/sign", param, "form");
  }
  //退出
  static postBowOut(param) {
    return post("/logout", param, "form");
  }

  /**
   * 商户管理
   * */
  static getCoopList(param) {
    return get("/cooperator/list/byAgent", param, "form");
  }
  // 代理商户端增加商户费率查看
  static getShowRate(param) {
    return get("/cooperator/show/rate", param, "form");
  }

  /**
   * 消息管理
   * */
  //消息列表
  static postNoticeList(param) {
    return post("/deal/notice/list", param, "form");
  }
  //消息列表详情
  static getNoticeListDetail(param) {
    return get("/deal/notice/detail", param, "form");
  }
  //消息详情 - 是否已读
  static getNoticeIsRead(param) {
    return get("/deal/notice/detail", param, "form");
  }

  /**
   * 自由职业者管理
   */
  //个体户信息管理列表
  static postPersonalBusinessList(params) {
    return post(
      "/worker/deal/individual/individualBusinessList",
      params,
      "form"
    );
  }
  //个体户管理更换64位图片
  static postFileBase(params) {
    return post("/file/getFileBase", params, "form");
  }
  //个体户订单列表
  static getPersonalOrderLis(params) {
    return get("/hire/order/find/page", params, "form");
  }
  //自由职业者审核 - 邀请码
  static postInviteCode(params) {
    return post("/worker/create/invitation/code", params, "json");
  }
  //自由职业者审核 - 更换手机号
  static postChangeMobile(params) {
    return post("/worker/hire/worker/modify/workerMobile", params, "form");
  }

  /**
   * 用工中心
   * */
  // 结算单列表
  static getSalaryList(param) {
    return get("/batch/salary/queryBatch", param, "form");
  }
  static getPositionList(param) {
    return get("/DistributionIndustry/find/position/list", param, "form");
  }
  // 用工结算单-查询是否允许批量结算
  static getQueryBatchMultiSalaryCheck(param) {
    return get("/batch/salary/queryBatchMultiSalaryCheck", param, "form");
  }
  //  用工结算单-创建批量结算记录
  static postCreateBatchMultiSalaryRecord(param) {
    return post("/batch/salary/createBatchMultiSalaryRecord", param, "json");
  }
  // 用工结算单-批量结算发送验证码
  static postSendBatchMultiSalaryCaptcha(param) {
    return post("/batch/salary/sendBatchMultiSalaryCaptcha", param, "json");
  }
  // 用工结算单-批量结算提交验证码
  static postPayBatchMultiSalaryRecordWithCaptcha(param) {
    return post(
      "/batch/salary/payBatchMultiSalaryRecordWithCaptcha",
      param,
      "json"
    );
  }
  //自由职业者列表- 批量导出协议
  static getExportAgreement(params) {
    return post("/worker/download/worker/contract/v2", params, "json");
  }
  // 查询系统配置任务二维码类型
  static getPositionCodeType(params) {
    return get("/web/query/position/qrc", params, "form");
  }
  // 报名详情导出
  static postSignInfoExport(params) {
    return post("/cooperator/position/async/export/agreement", params, "form");
  }
  // 用工中心 - 查询任务说明书
  static postGetMissionList(params) {
    return post("/select/missionStatementList", params, "json");
  }
  // 用工中心 - 添加任务说明书
  static posAddMission(params) {
    return post("/save/missionStatement", params, "json");
  }
  // 用工中心 - 编辑任务说明书
  static posUploadMission(params) {
    return post("/update/missionStatement", params, "json");
  }
  // 用工中心 - 删除任务说明书
  static posDeleteMission(params) {
    return post("/delete/missionStatement", params, "form");
  }
  // 自由职业者列表 - 置为无效
  static postLoseEfficacy(params) {
    return post(
      "/worker/hire/worker/let/worker/hire/sign/again",
      params,
      "form"
    );
  }
  // 用工结算单 - 选择优惠券
  static postSelectCoupon(params) {
    return post("/batch/salary/select/coupon", params, "json");
  }
  // 用工结算单 - 优惠券列表
  static getCouponList(params) {
    return get("/batch/salary/find/my/coupon/by/batchId", params, "form");
  }
  // 添加董监高白名单
  static postAddCooperatorStaffWhiteList(params) {
    return post(
      "/cooperator/staff/addCooperatorStaffWhiteList/4/web",
      params,
      "json"
    );
  }
  // 查询董监高审核状态
  static getFindStaffWhiteListState(params) {
    return get("/cooperator/staff/findStaffWhiteListState", params, "form");
  }
  // 取消结算单
  static postCancelSalaryBatch(param) {
    return post("/batch/salary/cancelBatch", param, "form");
  }
  // 结算单详情
  static postSalaryBatchDetailInfo(param) {
    return post("/batch/salary/queryBatchInfo", param, "form");
  }
  // 获取填写承诺书内容
  static postGetLetterSignInfo(param) {
    return post("/getLetterCommitmentContent", param, "form");
  }
  // 签署申诉承诺书身份验证
  static postAppealSmsVerify(param) {
    return post("/signIdentityAuthentication", param, "json");
  }
  // 签署申诉承诺书
  static postSignAppeal(param) {
    return post("/signAppealCommitmentLetter", param, "json");
  }
  // 查询工单列表
  static postSalaryBatchDetailList(param) {
    return post(
      "/batch/list/salary/queryUploadedBatchListByBatchId",
      param,
      "json"
    );
  }
  // 提交页面，查询累计结算金额是否超过175万
  static getQueryBatchListResult(param) {
    return get("/batch/list/salary/queryExcessPerson", param, "form");
  }
  // 删除工单
  static postSalaryBatchDelete(param) {
    return post("/batch/list/salary/deleteList", param, "form");
  }
  // 查询工单明细表
  static postEmployeeDetailList(param) {
    return post("/batch/list/salary/qeurySalaryInfo", param, "form");
  }
  // 下发明细
  static postDistributeDetailList(param) {
    return post("/batch/salary/query/worker/distributes", param, "form");
  }
  // 发送验证码-安心签
  static getSalaryBatchSmsCode(param) {
    return get("/batch/salary/sendBatchPaySms", param, "form");
  }
  // 网商-发送验证码
  static getMBKSendBatchPaySmsCode(param) {
    return get("/mbk/batch/salary/sendBatchPaySmsCode", param, "form");
  }
  // 发送验证码
  static getSendBatchPaySmsCode(param) {
    return get("/batch/salary/sendBatchPaySmsCode", param, "form");
  }
  // 短信验证
  static postSalaryBatchSmsVerify(param) {
    return post("/batch/salary/smsPayVerify", param, "form");
  }
  // 查询用工结算明细
  static getBatchListDealDesc(param) {
    return get("/batch/list/salary/batchListDealInfoQuery", param, "form");
  }
  // 管理费退还明细
  static getEmploymentDescList(param) {
    return get("", param, "form");
  }

  // 更换卡号
  static postUpdateBankNoAndJobStatus(param) {
    return post("/position/updatePositionWorkerHire", param, "json");
  }
  //二维码
  static getShareCode(param) {
    return get(
      "/cooperator/position/share/position/qrc/to/worker",
      param,
      "form"
    );
  }
  //提交前确认是否开通CFCA
  static postCheckIsCFCA(param) {
    return post("/batch/salary/submitVerify", param, "form");
  }
  //删除用工明细
  static postDeleteSalaryInfo(param) {
    return post("/batch/list/salary/deleteSalaryInfo", param, "form");
  }
  //编辑用工明细
  static postEditSalaryInfo(param) {
    return post("/batch/list/salary/modifySalaryInfo", param, "form");
  }
  //删除结算单
  static postDeleteInfo(param) {
    return post("/batch/salary/removeBatch", param, "form");
  }
  //入回收站
  static postRecycleBin(param) {
    return post(
      "/cooperator/position/push/or/pop/hire/worker/in/recycle/bin",
      param,
      "form"
    );
  }
  //回收站列表
  static getRecycleBinList(param) {
    return get(
      "/cooperator/position/find/recycle/bin/hire/worker/list",
      param,
      "form"
    );
  }
  // 一键录用
  static postOneClickHire(param) {
    return post(
      "/cooperator/position/one/click/recruitment/worker",
      param,
      "form"
    );
  }
  // 用工结算单--查询职位列表
  static postPositionList(param) {
    return post("/cooperator/position/queryCooperatorPosition", param, "form");
  }
  // 用工中心 - 自由职业者列表
  static getWorkerList(param) {
    return post("/worker/hire/worker/list", param, "json");
  }
  // 用工中心 - 自由职业者列表 - 自由职业者列表是否展示附件协议签署状态筛选及字段
  static getShowSupplementalSignState(param) {
    return get("/worker/whether/show/supplemental/sign/state", param, "form");
  }
  // 用工中心 - 修改备注
  static postModifyWorkerNotes(param) {
    return post("/worker/hire/worker/modify/worker/notes", param, "form");
  }
  // 查看单个人的协议
  static getSignFileList(param) {
    return get("/worker/hire/see/worker/sign/file", param, "form");
  }
  // 用工中心 - 编辑人员
  static postEditWorkerInfo(param) {
    return post("/batch/list/salary/modifyBatchList", param, "form");
  }
  // 邮箱集合
  static getEmailList(params) {
    return get("/get/account/email", params, "form");
  }
  // 制单 - 发送邮件
  static getDocPre(params) {
    return get("/make/bills/send/email", params, "form");
  }
  // 审核 - 发送邮件
  static getSendEmail(params) {
    return get("/approval/send/email", params, "form");
  }
  // 自由职业者列表 - 导出数据
  static getWorkerListExport(param) {
    return post("/worker/hire/worker/list/export", param, "json");
  }
  // 指定人员列表
  static postDesignatedPersonsList(param) {
    return post("/get/nameAndMobile/byPositionId", param, "json");
  }
  // 查看自由职业者协议
  static getFreelancerProtocol(param) {
    return get("/worker/hire/see/worker/sign/file", param, "form");
  }
  // 证明类文件列表
  static getProofFileList(param) {
    return get("/web/worker/prove/list/for/web", param, "form");
  }
  // 证明类文件生成
  static postProofFileSave(param) {
    return post("/web/worker/prove/generate", param, "json");
  }
  // 查询收款信息差异数据
  static getWorkerAccountErrorRecordPage(param) {
    return get("/worker/getWorkerAccountErrorRecordPage", param, "form");
  }
  // 任务信息维护
  static getComplianceCenterList(params) {
    return get(
      "/web/cooperator/position/compliance/center/list",
      params,
      "form"
    );
  }
  // 根据任务类型展示合规材料说明
  static getComplianceMaterialsByPositionType(params) {
    return get(
      "/web/cooperator/position/complianceMaterials/byPositionType",
      params,
      "form"
    );
  }
  // 重新提交上传结算单
  static postReUpload(params) {
    return post("/batch/salary/batchImport", params, "form");
  }
  // 用工中心——灵工管理列表
  static getSchedulingManagementList(params) {
    return get("/cooperator/webPositionScheduleListPage", params, "form");
  }
  // 用工中心——用工确认记录列表
  static getPositionScheduleConfirmListPag(params) {
    return get(
      "/cooperator/webPositionScheduleConfirmListPage",
      params,
      "form"
    );
  }
  // 用工中心——用工确认记录详情列表分页:项目制
  static getPositionScheduleConfirmListPage20(params) {
    return get(
      "/cooperator/webPositionScheduleConfirmListPage20",
      params,
      "form"
    );
  }
  // 用工中心——用工确认记录详情列表分页:工时制
  static getPositionScheduleConfirmListPage10(params) {
    return get(
      "/cooperator/webPositionScheduleConfirmListPage10",
      params,
      "form"
    );
  }
  // 用工中心——用工确认记录详情单个编辑:工时制
  static postPositionScheduleConfirmSingleUpdate10(params) {
    return post(
      "/cooperator/webPositionScheduleConfirmSingleUpdate10",
      params,
      "json"
    );
  }
  // 用工中心——用工确认记录详情单个编辑:项目制
  static postPositionScheduleConfirmSingleUpdate20(params) {
    return post(
      "/cooperator/webPositionScheduleConfirmSingleUpdate20",
      params,
      "json"
    );
  }
  // 用工确认记录整体确认
  static postPositionScheduleConfirmAllAudit(params) {
    return post(
      "/cooperator/webPositionScheduleConfirmAllAudit",
      params,
      "json"
    );
  }
  // 用工确认记录生成结算单
  static postPositionScheduleConfirmGenerateSettlement(params) {
    return post(
      "/cooperator/webPositionScheduleConfirmGenerateSettlement",
      params,
      "json"
    );
  }

  // 商户查询可用的任务列表
  static getFindAvailablePositionList(params) {
    return get(
      "/whiteness/cooperator/findAvailablePositionList",
      params,
      "form"
    );
  }
  // 用工中心——创建班次
  static postWebPositionScheduleCreate(params) {
    return post("/cooperator/webPositionScheduleCreate", params, "json");
  }
  // 用工中心——更新班次
  static postWebPositionScheduleUpdate(params) {
    return post("/cooperator/webPositionScheduleUpdate", params, "json");
  }
  // 用工中心— 开启排班
  static postWebPositionScheduleOpen(params) {
    return post("/cooperator/webPositionScheduleOpen", params, "form");
  }
  // 用工中心— 关闭排班
  static postWebPositionScheduleClose(params) {
    return post("/cooperator/webPositionScheduleClose", params, "form");
  }
  // 用工中心— 删除班次
  static postWebPositionScheduleDelete(params) {
    return post("/cooperator/webPositionScheduleDelete", params, "form");
  }
  // 用工中心— 排班人员列表
  static getWebPositionScheduleArrangeList(params) {
    return get("/cooperator/webPositionScheduleArrangeList", params, "form");
  }
  // 用工中心— 任务人员排班列表分页
  static getWebPositionWorkerScheduleListPage(params) {
    return get("/cooperator/webPositionWorkerScheduleListPage", params, "form");
  }
  // 用工中心— 任务人员在岗
  static postWebPositionWorkerScheduleOnJob(params) {
    return post("/cooperator/webPositionWorkerScheduleOnJob", params, "json");
  }
  // 用工中心— 任务人员离岗
  static postWebPositionWorkerScheduleOffJob(params) {
    return post("/cooperator/webPositionWorkerScheduleOffJob", params, "json");
  }
  // 用工中心— 根据任务查询排班
  static getWebPositionScheduleListByPositionId(params) {
    return get(
      "/cooperator/webPositionScheduleListByPositionId",
      params,
      "form"
    );
  }
  // 用工中心— 批量配置任务排班
  static postWebPositionWorkerScheduleBatchArrange(params) {
    return post(
      "/cooperator/webPositionWorkerScheduleBatchArrange",
      params,
      "json"
    );
  }
  // 用工中心 - 测算工具列表
  static getPreCalculateBatchListPage(params) {
    return get("/batch/salary/preCalculateBatchListPage", params, "form");
  }
  // 用工中心 - 删除单个测算批次
  static postDelPreCalculateBatch(params) {
    return post("/batch/salary/deletePreCalculateBatch", params, "json");
  }
  // 用工中心 - 测算流水列表分页
  static getPreCalculateBatchListListPage(params) {
    return get("/batch/salary/preCalculateBatchListListPage", params, "json");
  }
  // 用工中心 - 测算流水列表分页
  static postPreCalculateBatchSubmit(params) {
    return post("/batch/salary/preCalculateBatchSubmit", params, "json");
  }
  // 查询全部开启的排班
  static getPositionScheduleList(params) {
    return get("/whiteness/cooperator/webPositionScheduleList", params, "form");
  }
  // 考勤列表
  static getPositionScheduleAttendanceListPage(params) {
    return get(
      "/cooperator/webPositionScheduleAttendanceListPage",
      params,
      "form"
    );
  }
  // 交付物列表
  static getPositionScheduleDeliveryListPage(params) {
    return get(
      "/cooperator/webPositionScheduleDeliveryListPage",
      params,
      "form"
    );
  }

  /**
   *
   * 招聘列表（原任务管理）
   * */
  // 创建任务
  static postCreateTask(params) {
    return post("/task/taskCreate", params, "form");
  }
  // 任务列表 - 无专属任务
  static postTaskList(params) {
    return post("/cooperator/position/find/all/position", params, "json");
  }
  // 分享小程序二维码
  static getShareMiNiCode(params) {
    return get("/cooperator/position/share/getHvyogoAppletOrc", params, "json");
  }
  // 分享小程序二维码（便利风）
  static getShareBlfCode(params) {
    return get(
      "/single/cooperator/position/share/getHzbAppletOrc",
      params,
      "json"
    );
  }
  // 任务删除
  static postTaskDel(params) {
    return post("/cooperator/position/del/cooperator/position", params, "form");
  }
  //报名详情 - 共青城商户
  static getApplicDetailGQC(params) {
    return get(
      "/cooperator/position/find/position/worker/by/positionId",
      params,
      "form"
    );
  }
  //报名详情 - 非共青城商户
  static getApplicDetailNormal(params) {
    return get(
      "/cooperator/position/hyg/find/position/worker/by/positionId",
      params,
      "form"
    );
  }
  // 上下线任务
  static postUpdateRecruitState(params) {
    return post(
      "/cooperator/position/update/position/recruitmentstate",
      params,
      "form"
    );
  }
  // 任务类型
  static getTaskTypeList(params) {
    return get("/find/serviceType", params, "form");
  }
  //拒绝或者录用 - 共青城商户
  static postSignUpOperaGQC(params) {
    return post(
      "/cooperator/position/batch/update/worker/state",
      params,
      "form"
    );
  }
  //拒绝或者录用 - 非共青城商户
  static postSignUpOperaNormal(params) {
    return post(
      "/cooperator/position/hyg/batch/update/worker/state",
      params,
      "form"
    );
  }
  //新增&&修改任务
  static postAddOrUpdateTask(params) {
    return post(
      "/cooperator/position/create/or/update/position",
      params,
      "form"
    );
  }
  //回显任务详情
  static getTaskInfo(params) {
    return get(
      "/cooperator/position/find/position/by/positionId",
      params,
      "form"
    );
  }
  // 批量邀请列表查询
  static getBatchInvitation(params) {
    return get("/findBatchInvitationRecord", params, "form");
  }
  // 根据商户id查询对应任务
  static getPositionByCooperatorId(params) {
    return get("/selectPositionByCooperatorId", params, "form");
  }
  // 生成任务详情
  static postCooperatorPositionGenerateInfo(params) {
    return post("/cooperator/position/generate/info", params, "form");
  }
  // xjh-获取任务计费单位
  static getCooperatorPositionUnitList(params) {
    return get("/cooperator/position/unit/list", params, "form");
  }
  // xjh-获取岗位目录
  static getPositionJobQueryAllCategory(params) {
    return get("/position/job/query/all/category", params, "form");
  }
  // xjh-获取二级类目计费范围
  static getPositionJobQueryAmountRange(params) {
    return get("/position/job/query/amount/range", params, "form");
  }
  // xjh-获取服务地点
  static getCooperatorPositionWorkLocationList(params) {
    return get("/cooperator/position/get/work/location/list", params, "form");
  }
  // xjh-检查是否需要进行[发布任务功能升级]通知
  static getCooperatorPositionCheckNoticeState(params) {
    return get("/cooperator/position/check/notice/state", params, "form");
  }
  // xjh-标记已读[发布任务功能升级]通知
  static postCooperatorPositionMarkNoticeRead(params) {
    return post("/cooperator/position/mark/notice/read", params, "form");
  }

  /**
   * 资金下发管理
   */
  //关联任务
  static getAssociatedTask(params) {
    return get("/batch/find/position/list/gqc", params, "form");
  }

  /**
   * 登录账号
   */
  //登录账号列表
  static postAccList(params) {
    return post("/find/login/account/list", params, "form");
  }
  //登录
  static postAccLogin(params) {
    return post("/no/pwd/login", params, "form");
  }

  /**
   * 任务中心 -- 针对江西慧用工
   */
  //任务中心列表
  static postJXTaskCenList(params) {
    return post(
      "/single/cooperator/position/find/all/position",
      params,
      "json"
    );
  }
  //江西慧用工任务上下线
  static postJXUpdateRecruitState(params) {
    return post(
      "/single/cooperator/position/update/position/recruitmentstate",
      params,
      "form"
    );
  }
  //江西慧用工任务删除
  static postJXTaskDel(params) {
    return post(
      "/single/cooperator/position/del/cooperator/position",
      params,
      "form"
    );
  }
  //江西慧用工任务详情
  static getJXApplicDetail(params) {
    return get(
      "/single/cooperator/position/find/position/worker/by/positionId",
      params,
      "form"
    );
  }
  //江西慧用工新增&&修改任务
  static postJXAddOrUpdateTask(params) {
    return post(
      "/single/cooperator/position/create/or/update/position",
      params,
      "form"
    );
  }
  //江西慧用工回显任务详情
  static getJXTaskInfo(params) {
    return get(
      "/single/cooperator/position/find/position/by/positionId",
      params,
      "form"
    );
  }
  // 江西慧用工任务类型
  static getJXTaskTypeList(params) {
    return get("/single/cooperator/position/find/serviceType", params, "form");
  }

  /**
   * 合规中心 -- 针对风控
   */
  // 查看商户是否填写合作评估表
  static postCenterWhetherCompliance(params) {
    return post("/center/whether/write/Complian", params, "form");
  }
  // 查询合作评估表中心
  static postSelectCooperationevalue(params) {
    return post("/center/select/cooperation/evaluation", params, "form");
  }
  // 保存/编辑合规中心表
  static postSaveCooperationevalue(params) {
    return post("/center/save/cooperation/evaluation", params, "json");
  }

  /**
   * 线上合同信息补全
   */
  // 更新合同发票信息
  static postUpdateContractInvoiceInfo(params) {
    return post(
      "/whiteness/cooperator/contract/updateContractInvoiceInformation",
      params,
      "json"
    );
  }
  // 更新合同法人信息
  static postUpdateContractPersonInfo(params) {
    return post(
      "/whiteness/cooperator/contract/updateContractLegalPersonInformation",
      params,
      "json"
    );
  }
  // 更新支付验证信息(调起电子牵)
  static postUpdateContractPaymentInfo(params) {
    return post(
      "/whiteness/cooperator/contract/updateContractPaymentInformation",
      params,
      "json"
    );
  }
  // 更新支付验证信息(调起电子牵)
  static postVerifyPaymentAmount(params) {
    return post(
      "/whiteness/cooperator/contract/verifyPaymentAmount",
      params,
      "json"
    );
  }
  // 商户合同列表
  static postCooperatorSignContractList(params) {
    return post("/find/cooperator/sign/contract/list", params, "form");
  }

  /**
   * 恢复线上合同签署
   */
  // 是否需要补全合同信息
  static getIsNeedCompleteContractInformation(params) {
    return get(
      "/whiteness/cooperator/contract/isNeedCompleteContractInformation",
      params,
      "form"
    );
  }
  // 各个信息维护状态
  static getQueryOnlineContractInformation(params) {
    return get(
      "/whiteness/cooperator/contract/queryOnlineContractInformation",
      params,
      "form"
    );
  }
  // 更新合同经办人信息
  static postUpdateContractOperatorInfo(params) {
    return post(
      "/whiteness/cooperator/contract/updateContractOperatorInformation",
      params,
      "json"
    );
  }
  // 维护企业收款信息 发起小额打款
  static postUpdatePaymentInformation(params) {
    return post(
      "/whiteness/cooperator/contract/updatePaymentInformation",
      params,
      "json"
    );
  }
  // 支付验证码验证
  static postVerifyPaymentAndSmsCode(params) {
    return post(
      "/whiteness/cooperator/contract/verifyPaymentAmountAndSmsCode",
      params,
      "json"
    );
  }
  // 查询商户合同数据
  static postWhitenessCooperatorData(params) {
    return post("/whiteness/cooperator/get/contract/data", params, "form");
  }
  // 经办人列表
  static postHandledByList(params) {
    return post("/whiteness/cooperator/find/operatorList", params, "json");
  }
  // 经办人发送验证码
  static postContractSendSms(params) {
    return post("/whiteness/cooperator/sign/contract/send/sms", params, "form");
  }
  // 签署合同 验证验证码
  static postCooperatorSignContract(params) {
    return post("/whiteness/cooperator/sign/contract", params, "form");
  }
  // 经办人管理列表
  static postOperatorList(params) {
    return post("/find/cooperator/OperatorList", params, "form");
  }
  // 首页 - 更换经办人
  static getChangeManager(params) {
    return get(
      "/whiteness/cooperator/replace/operator/information",
      params,
      "form"
    );
  }

  /**
   * 优惠券中心
   */
  // 优惠券管理列表
  static getDiscountCouponManageList(params) {
    return get("/web/coupon/management/page", params, "form");
  }
  // 优惠券使用详情
  static getCouponDetail(params) {
    return get("/web/coupon/usage/detail", params, "form");
  }

  // 查询商户字段
  static getFindCooperatorConfField(params) {
    return get("/cooperator/findCooperatorConfField", params, "form");
  }
}



// WEBPACK FOOTER //
// ./src/service/apiscopy.js